import { render, staticRenderFns } from "./Hints.vue?vue&type=template&id=18b45d3e&scoped=true&"
import script from "./Hints.vue?vue&type=script&lang=ts&"
export * from "./Hints.vue?vue&type=script&lang=ts&"
import style0 from "./Hints.vue?vue&type=style&index=0&id=18b45d3e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b45d3e",
  null
  
)

export default component.exports